// extracted by mini-css-extract-plugin
module.exports =  {"externalVideoLink":"style-module_externalVideoLink__kjQ88H6FbHMcChohCCLf"};